export const CLIENT_ID = process.env.REACT_APP_Paypal_CLIENT_ID
export const APP_SECRET = process.env.REACT_APP_Paypal_APP_SECRET